export const FIREBASE_PROJECT_IDS = {
  PRODUCTION: "entspannungshelden-app",
  DEVELOPMENT: "entspannungshelden-app-dev",
} as const;
